import React, { useRef, useState } from "react";
import api, { mediaUrl } from "../lib/api";
import { logError } from "../lib/log";
import { useLang } from "../lib/i18n";
import { Camera, X, Loader2 } from "lucide-react";

export const PhotoUploader = ({ photos, setPhotos, max = 5, testid = "photo-uploader" }) => {
  const { t } = useLang();
  const inputRef = useRef();
  const [busy, setBusy] = useState(false);

  const onPick = async (e) => {
    const files = Array.from(e.target.files || []).slice(0, max - photos.length);
    if (!files.length) return;
    setBusy(true);
    try {
      const fd = new FormData();
      files.forEach((f) => fd.append("files", f));
      const { data } = await api.post("/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
      setPhotos([...photos, ...data.urls]);
    } catch (err) {
      logError(err);
    } finally {
      setBusy(false);
      if (inputRef.current) inputRef.current.value = "";
    }
  };

  return (
    <div data-testid={testid}>
      <div className="grid grid-cols-3 gap-3">
        {photos.map((p, i) => (
          <div key={i} className="relative aspect-square overflow-hidden rounded-xl border border-slate-200">
            <img src={mediaUrl(p)} alt="" className="h-full w-full object-cover" />
            <button type="button" data-testid={`remove-photo-${i}`} onClick={() => setPhotos(photos.filter((_, j) => j !== i))}
              className="absolute right-1 top-1 rounded-full bg-black/60 p-1 text-white">
              <X className="h-3.5 w-3.5" />
            </button>
          </div>
        ))}
        {photos.length < max && (
          <button type="button" data-testid="add-photo-btn" onClick={() => inputRef.current?.click()} disabled={busy}
            className="flex aspect-square flex-col items-center justify-center gap-1 rounded-xl border-2 border-dashed border-slate-300 bg-slate-50 text-slate-500 transition hover:border-blue-400 hover:text-blue-600">
            {busy ? <Loader2 className="h-6 w-6 animate-spin" /> : <Camera className="h-6 w-6" />}
            <span className="text-[11px] font-semibold">{busy ? t("uploading") : t("add_photo")}</span>
          </button>
        )}
      </div>
      <input ref={inputRef} type="file" accept="image/*" multiple capture="environment" onChange={onPick} className="hidden" />
    </div>
  );
};
